// extracted by mini-css-extract-plugin
module.exports = {"lightLabelOnGoing":"countDownLabel_lightLabelOnGoing__v6j5q","lightLabelBeGoing":"countDownLabel_lightLabelBeGoing__puX0Q"};